import React from "react";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import LayoutColumn from "../components/LayoutColumn";

export default () => {
  return (
    <Layout>
      <SEO title="About" />
      <LayoutColumn>
        <p>
          My professional journey began in 2007 when I entered a small web
          development laboratory at my university. I was studying computer
          science as my primary degree, building compilators, and Matlab
          simulations. Laboratory was optional and offered practice in web
          development and server administration. I was instantly hooked by the
          beauty of the Web. CSS Zen Garden and design studios were my infinite
          source of inspiration. I graduated in 2008 and already had a job as a
          full-stack web developer.
        </p>
        <p>
          Although, I rather quickly shifted from full-stack to front-end
          development. I was perfecting my CSS and JavaScript skills on various
          sites and applications. With front-end experience came understanding
          of a basic principles of UX. And frustration when designers ignore
          these principles. I started to learn more about interfaces and
          user-centered design.
        </p>
        <p>
          It took me a while to figure out that I love the design process more
          than programming. I continued my studies, devouring lists of must-read
          books on the subjects of user experience, typography, information
          design, data visualization, editing, and so on. In my evenings and
          weekends, I practiced designing personal and university projects.
          Later in 2013, I joined Usethics usability company as a UX designer.
          There I designed web, mobile, and kiosk applications for their
          clients. I worked only on the UX part because UI was outsourced.
        </p>
        <p>
          However, I quickly realized that it is not the best way to separate UI
          and UX completely. When UI-designer works after UX fellow, she either
          throws away part of UX and make it from scratch or just change
          typography and icons. So I started to look for a job where these parts
          were inseparable. And gain more knowledge in graphic design,
          typography, and layout. I applied to the Artem Gorbunov design school
          where I practiced all these things, alongside negotiations, editing,
          and time management. In 2014 I took an opportunity to join a team of
          Yandex, Russian internet search company, as a product designer. There
          I worked on their main page and other projects in the fields of news,
          search, and entertainment. Later in 2017 I joined Yandex Navigator
          team and worked on an application for drivers.
        </p>
        <p>
          2019 was a family year for me. After working for almost five years at
          Yandex something was missing. We took a sabbatical to ponder on the
          most valuable things. And it turned out great! My wife and I finally
          were able to have a baby. I worked part-time and somehow got back to
          programming. I was overwhelmed and excited about how things had
          changed in the last few years. Now I'm learning React and d3.js and
          use it for personal and client's projects. And I'm looking for the
          opportunity to combine my design and programming skills to make better
          products.
        </p>
      </LayoutColumn>
    </Layout>
  );
};
